/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetDevourStatsResponseData
 */
export interface GetDevourStatsResponseData {
    /**
     * The user's GoVIP level
     * @type {number}
     * @memberof GetDevourStatsResponseData
     */
    goVipLevel?: number;
    /**
     * The user's GoVIP experience points
     * @type {number}
     * @memberof GetDevourStatsResponseData
     */
    goVipXP?: number;
    /**
     * Boolean of whether the user has the industry pass
     * @type {boolean}
     * @memberof GetDevourStatsResponseData
     */
    industryPassHolder?: boolean;
}

/**
 * Check if a given object implements the GetDevourStatsResponseData interface.
 */
export function instanceOfGetDevourStatsResponseData(value: object): value is GetDevourStatsResponseData {
    return true;
}

export function GetDevourStatsResponseDataFromJSON(json: any): GetDevourStatsResponseData {
    return GetDevourStatsResponseDataFromJSONTyped(json, false);
}

export function GetDevourStatsResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDevourStatsResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'goVipLevel': json['goVipLevel'] == null ? undefined : json['goVipLevel'],
        'goVipXP': json['goVipXP'] == null ? undefined : json['goVipXP'],
        'industryPassHolder': json['industryPassHolder'] == null ? undefined : json['industryPassHolder'],
    };
}

export function GetDevourStatsResponseDataToJSON(json: any): GetDevourStatsResponseData {
    return GetDevourStatsResponseDataToJSONTyped(json, false);
}

export function GetDevourStatsResponseDataToJSONTyped(value?: GetDevourStatsResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goVipLevel': value['goVipLevel'],
        'goVipXP': value['goVipXP'],
        'industryPassHolder': value['industryPassHolder'],
    };
}

